import "core-js/modules/es6.date.now";
export var formatDate = function formatDate(d) {
  return "".concat(d.getFullYear(), "-").concat(d.getMonth() + 1, "-").concat(d.getDate());
};
export var dateToAge = function dateToAge(dob) {
  if (dob === null || dob === undefined) {
    return dob;
  }

  var ageDifMs = Date.now() - new Date(dob).getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch

  return Math.abs(ageDate.getUTCFullYear() - 1970);
};
export var ageToDate = function ageToDate(age) {
  var today = new Date();
  var birthDate = new Date(Date.UTC(today.getUTCFullYear(), 0, 1, 0, 0, 0));
  birthDate.setUTCFullYear(today.getUTCFullYear() - age);
  return formatDate(birthDate);
};
export var ageAtYear = function ageAtYear(currentAge, year) {
  var thisYear = new Date().getUTCFullYear();
  return year - thisYear + currentAge;
};